import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { callGet } from "./local";

export default function Private() {
  const auth = callGet("auth");
  return auth?.ClientToken ? <Outlet /> : <Navigate to="/" />;
}
